import React from "react";
import { Link } from "react-router-dom";
import { HOME_PROMO_CARDS } from "../../content/homeMarketing";
import "../MarketingPages.css";

function PartnerIcon() {
  return (
    <svg viewBox="0 0 80 80" fill="none" aria-hidden="true">
      <g transform="translate(8 30) rotate(-18 18 22)">
        <rect x="6" y="4" width="24" height="40" rx="5" fill="var(--primary, #18442a)" stroke="#0e1726" strokeWidth="2" />
        <rect x="10" y="10" width="16" height="26" rx="2.5" fill="#fff" />
        <rect x="14" y="7" width="8" height="2" rx="1" fill="#0e1726" />
      </g>
      <g transform="translate(38 30) rotate(18 18 22)">
        <rect x="6" y="4" width="24" height="40" rx="5" fill="var(--primary, #18442a)" stroke="#0e1726" strokeWidth="2" />
        <rect x="10" y="10" width="16" height="26" rx="2.5" fill="#fff" />
        <rect x="14" y="7" width="8" height="2" rx="1" fill="#0e1726" />
      </g>
    </svg>
  );
}

function OwnerIcon() {
  return (
    <svg viewBox="0 0 80 80" fill="none" aria-hidden="true">
      <rect x="14" y="18" width="52" height="44" rx="8" fill="var(--primary, #18442a)" stroke="#0e1726" strokeWidth="2" />
      <rect x="20" y="26" width="40" height="28" rx="4" fill="#fff" />
      <rect x="26" y="32" width="14" height="3" rx="1.5" fill="var(--primary, #18442a)" />
      <rect x="26" y="40" width="28" height="3" rx="1.5" fill="#E4DBC4" />
      <rect x="26" y="48" width="22" height="3" rx="1.5" fill="#E4DBC4" />
      <circle cx="56" cy="24" r="10" fill="#ffaa06" stroke="#0e1726" strokeWidth="2" />
      <path
        d="M52 24l3 3 6-6"
        stroke="#18442a"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const promoIconByKey = {
  partner: PartnerIcon,
  owner: OwnerIcon,
};

export default function HomePromoCards({ t, lang }) {
  return (
    <section
      className={`home-promo container ${lang === "ar" ? "rtl" : ""}`}
      aria-label={lang === "ar" ? "فرص مع احجزلي" : "Opportunities with Ehgezly"}
    >
      <div className="home-promo__grid">
        {HOME_PROMO_CARDS.map(({ key, to, icon, titleKey, descKey, ctaKey }) => {
          const Icon = promoIconByKey[icon];
          return (
            <Link key={key} to={to} className={`promo-card promo-card--${key}`}>
              <div className="promo-card__top">
                <div className="promo-card__icon">{Icon && <Icon />}</div>
                <div className="promo-card__copy">
                  <h3 className="promo-card__title">{t[titleKey]}</h3>
                  <p className="promo-card__desc">{t[descKey]}</p>
                </div>
              </div>
              <span className="promo-card__btn">{t[ctaKey]}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
